import { gql } from '@apollo/client';

const UPDATE_WIDGET = gql(/* GraphQL */ `
  mutation UpdateObj($widgetId: UUID!, $values: [PropertyByKeyInput]) {
    updateObjectWithProperties(input: { detailedObject: [{ objectId: $widgetId, keyedProperties: $values }] }) {
      clientMutationId
    }
  }
`);

export { UPDATE_WIDGET };
